import Axios from "../../config/Axios";
import Apis from "../../config/Apis";
import { headers } from "../../utills";
import { hideLoading, showAlert, showLoading } from "../Actions/GeneralActions";
import {
  get_cus_module_detail,
  get_cus_modules,
} from "../Actions/CusModuleAction";

export const CusModulesMiddleware = {
  getCusModules: ({ name }) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());

          let formdata = new FormData();
          formdata.append("name", name);

          const data = await Axios.post(
            Apis.cus_modules,
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            dispatch(get_cus_modules(data.data.data));
            resolve(data.data.data);
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "getModules",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  getModuleDetails: ({ id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          const data = await Axios.get(
            Apis.cus_moduleDetails(id),
            headers.config()
          );
          if (data?.status == 200) {
            dispatch(get_cus_module_detail(data.data.data));
            resolve(true);
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "getModuleDetails",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },

  shareAccess: ({ email, module_id, asset_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();
          formdata.append("email", email);
          if (module_id) formdata.append("module_id", module_id);
          if (asset_id) formdata.append("asset_id", asset_id);
          const data = await Axios.post(
            Apis.cus_shareAccess,
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(get_cus_module_detail(data.data.data));
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "shareAccess",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
  removeAccess: ({ user_id, asset_id }) => {
    return (dispatch) => {
      dispatch(showLoading());
      return new Promise(async (resolve, reject) => {
        try {
          let formdata = new FormData();

          if (user_id) formdata.append("user_id", user_id);
          if (asset_id) formdata.append("asset_id", asset_id);
          const data = await Axios.post(
            Apis.removeAccess,
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            resolve(true);
            dispatch(
            showAlert({
              title: "shareAccess",
              message: data?.data?.message,
              type: "success",
            })
          );
            dispatch(hideLoading());
            dispatch(get_cus_module_detail(data.data.data));
          }
        } catch (error) {
          dispatch(hideLoading());
          dispatch(
            showAlert({
              title: "shareAccess",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            })
          );
        }
      });
    };
  },
  createModule: (params) => {
    return (dispatch) => {
      return new Promise(async (resolve, reject) => {
        try {
          dispatch(showLoading());
          let formdata = new FormData();

          formdata.append("device_id", params?.device_id);

          if (params?.device_name)
            formdata.append("device_name", params?.device_name);

          const data = await Axios.post(
            Apis.cus_createModules,
            formdata,
            headers.config()
          );
          if (data?.status == 200) {
            dispatch(get_cus_modules(data.data.data));
            dispatch(
              showAlert({ type: "Success", message: data?.data?.message })
            );
            resolve(true);
          }
        } catch (error) {
          // reject(error);
          dispatch(
            showAlert({
              title: "createModule",
              message: error?.response?.data?.message
                ? error?.response?.data?.message
                : "Something went wrong!",
              type: "Error",
              status: error?.response?.status,
            })
          );
        } finally {
          dispatch(hideLoading());
        }
      });
    };
  },
};
